import { $isTextNode, TextNode } from 'lexical';

export function $copyStylesFromNeighbours(
  node: TextNode,
): void {
  const neighbour = node.getPreviousSibling() ?? node.getNextSibling();
  if ($isTextNode(neighbour)) {
    node.setStyle((neighbour).getStyle());
  }
}
